import { useState, useEffect, useMemo } from 'react';
import s from '../styles/pages/ViewMenu.module.css';
import MenuHeader from '../components/menu/MenuHeader';
import MenuSections from '../components/menu/MenuSections';
import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import site from '../data/master.json';
import RewardsToast from '../components/rewards/RewardsToast';


export default function ViewMenu() {
  const { label, title, menus } = site.menu;
  const [menuId, setMenuId] = useState(menus[0].id);
  const [hovered, setHovered] = useState(null);
  const [wide, setWide] = useState(true);

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 860px)');
    const update = () => setWide(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  const menu = useMemo(() => menus.find((m) => m.id === menuId) || menus[0], [menuId, menus]);

  return (
    <div>
      <Header />
      <section className={s.container} id="menu">
        <div className={s.inner}>
          <MenuHeader
            label={label}
            title={title}
            menus={menus}
            menuId={menuId}
            menu={menu}
            onMenuChange={setMenuId}
          />
          <MenuSections
            menu={menu}
            wide={wide}
            hovered={hovered}
            onHover={setHovered}
          />
        </div>
      </section>
      <Footer data={site.footer} />
      <RewardsToast />
    </div>
  );
}